import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants, currencyString } from "@qgiv/core-js";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectAllRegistration } from "../../../redux/slices/registrationSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import StoreItem from "./StoreItem";
import {
    setProductModalOpen,
    updateCurrentStoreCartItemIndex,
} from "../../../redux/slices/productModalSlice";

const ConnectedStoreItem = ({ controlId, product }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const {
        id,
        price_fixed = 0,
        price_low = 0,
        price_high = 0,
        hasAttributes = false,
    } = product;
    const registration = useSelector(selectAllRegistration);
    const { storeCart = [] } = registration;
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_P2P_STORE,
            state,
        ),
    );
    const {
        options: { displayPreviewOfProductDescription = 0 },
    } = control;
    const formSettings = useSelector(selectAllFormSettings);
    const { currency } = formSettings;

    const formattedPrice = price_fixed
        ? currencyString(price_fixed, currency)
        : currencyString(price_low, currency);

    const priceRangeEqual =
        formattedPrice === currencyString(price_high, currency);

    const productPrice =
        price_fixed || (!price_fixed && priceRangeEqual)
            ? formattedPrice
            : `${formattedPrice}-${price_high} ea.`;

    const displayDesc = !!(
        displayPreviewOfProductDescription && product.description.length > 0
    );

    // Update the current store item index if no attributes and product id
    // already exists in StoreCart array
    let indexOfItemAlreadyInCart;
    if (!hasAttributes && storeCart.length > 0) {
        indexOfItemAlreadyInCart = storeCart.findIndex(
            (item) => item.Product_Id === id,
        );
    } else {
        indexOfItemAlreadyInCart = undefined;
    }

    const storeItemProps = {
        displayDesc,
        indexOfItemAlreadyInCart,
        productPrice,
        product,
        setProductModalOpen,
        updateCurrentStoreCartItemIndex,
    };
    return <StoreItem {...storeItemProps} />;
};

ConnectedStoreItem.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    product: PropTypes.shape({
        id: PropTypes.number,
        price_fixed: PropTypes.number,
        price_low: PropTypes.number,
        price_high: PropTypes.number,
        hasAttributes: PropTypes.bool,
        description: PropTypes.string,
    }).isRequired,
};

export default ConnectedStoreItem;
